import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Collapse, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import React, { Component, Fragment } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import CategoryQuestionApi from 'apis/questions/CategoryQuestion';

import QuestionsLists from 'components/questions/modify/QuestionsLists';
import AddNewQuestion from 'components/customSurvey/questions/addNewQuestion';
import RearrangeQuestions from 'components/questions/modify/RearrangeQuestions';
import DeleteQuestionModal from 'components/questions/modals/deleteQuestion';

class QuestionsDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      question: '',
      answer: '',
      answers_attributes: [],
      answerError: '',
      questions: [],
      editId: '',
      editAnswerObject: {},
      editAnswerText: '',
      editAnswerIndex: '',
      modalToggle: false,
      questionId: '',
      questionError: '',
      rearrangeMode: false,
    };
  }

  componentWillMount() {
    this.props.fetchDetails();
    this.setState({ rearrangeMode: false });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      if (this.props.match.params.customSurveyId)
        this.setState({ rearrangeMode: false, collapse: false });
    }
  }

  changeAnswerOrder = (answers_attributes, answer_order) => {
    this.setState({ answers_attributes, answer_order });
  };

  toggleAddtrue = () => {
    this.setState({
      collapse: true,
      editId: '',
      question: '',
      answer: '',
      answers_attributes: [],
      questionError: '',
      answerError: '',
    });
  };

  toggleAddfalse = () => {
    this.setState({
      collapse: false,
      question: '',
      answer: '',
      answers_attributes: [],
    });
  };

  handleKeyPress = e => {
    if (e.key === 'Enter') {
      this.addAnswer();
    }
  };

  handleChange = e => {
    let _state = {};

    _state[e.target.name] = e.target.value;

    if (e.target.name === 'question') {
      _state.questionError = '';
    } else {
      _state.answerError = '';
    }

    this.setState(_state);
  };

  addAnswer = () => {
    let answers_attributes = this.state.answers_attributes;
    let answers = answers_attributes.filter(answer => {
      return !answer.is_deleted;
    });
    if (answers.length < 5) {
      if (this.state.answer.trim() != '' || null) {
        answers_attributes.push({ answer: this.state.answer });
        this.setState({
          answer: '',
          answers_attributes,
          answerError: '',
        });
      } else {
        this.setState({ answerError: 'Answer cannot be blank' });
      }
    } else {
      this.setState({ answerError: 'Maximum 5 answers only' });
    }
  };

  deleteQuestion = questionId => {
    this.setState({ modalToggle: true, questionId });
  };

  confirmDeleteQuestion = () => {
    CategoryQuestionApi.delete(this.state.questionId)
      .then(({ data }) => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Question deleted successfully
          </div>
        ));
        this.cancelQuestionDelete();
        this.props.fetchDetails();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while deleting question
            </div>
          )),
          console.log(e)
        )
      );
  };

  cancelQuestionDelete = () => {
    this.setState({ modalToggle: false });
  };

  editQuestion = editId => {
    this.setState({ editId, collapse: false });
    CategoryQuestionApi.getDetails(editId)
      .then(({ data }) => {
        this.setState({
          answers_attributes: data.answers,
          question: data.question,
          answer_order: data.answer_order,
        });
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while fetching question
            </div>
          )),
          console.log(e)
        )
      );
  };

  confirmEdit = questionObj => {
    const { question, answer_attributes } = questionObj;
    const { editId } = this.state;
    const answer_order = answer_attributes.map(({ id }) => id);

    CategoryQuestionApi.update(
      editId,
      question,
      answer_attributes,
      answer_order
    )
      .then(({ data }) => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Question updated successfully
          </div>
        ));
        this.setState({ editId: '' });
        this.props.fetchDetails();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while updating question
            </div>
          )),
          console.log(e)
        )
      );
  };

  cancelEdit = () => {
    this.setState({ editId: '', questionError: '', answerError: '' });
  };

  checkValidity = () => {
    const { question, answers_attributes } = this.state;
    const answers = answers_attributes.filter(answer => {
      return !answer.is_deleted;
    });
    if (question.trim() == '' || null) {
      this.setState({ questionError: 'Question field cannot be blank' });
      return false;
    }
    if (answers.length < 1) {
      this.setState({ questionError: 'Atleast one option is required' });
      return false;
    }
    return true;
  };

  addQuestion = newQuestion => {
    const { question, answer_attributes, input_type_id } = newQuestion;

    CategoryQuestionApi.addNew(
      question,
      answer_attributes,
      this.props.categoryId,
      input_type_id
    )
      .then(data => {
        toast.success(() => (
          <div>
            <FontAwesomeIcon icon="check-circle" />
            Question added successfully
          </div>
        ));
        this.toggleAddfalse();
        this.props.fetchDetails();
      })
      .catch(
        e => (
          toast.error(() => (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              Error while creating question
            </div>
          )),
          console.log(e)
        )
      );
  };

  editAnswer = editAnswerObject => {
    const answers_attributes = this.state.answers_attributes;
    const index = answers_attributes.indexOf(editAnswerObject);

    this.setState({
      editAnswerObject,
      editAnswerText: editAnswerObject.answer,
      editAnswerIndex: index,
    });
  };

  cancelAnswerEdit = () => {
    this.setState({
      editAnswerObject: {},
      editAnswerText: '',
      editAnswerIndex: '',
    });
  };

  confirmAnswerEdit = () => {
    if (this.state.editAnswerText.trim() != '' || null) {
      let answer = this.state.editAnswerText;
      let answers_attributes = this.state.answers_attributes;
      answers_attributes[this.state.editAnswerIndex].answer = answer;
      this.setState({
        answers_attributes,
        editAnswerObject: {},
        editAnswerText: '',
        editAnswerIndex: '',
      });
    } else {
      this.setState({ answerError: 'Answer cannot be empty' });
    }
  };

  handleQuestionArrange = () => {
    const { rearrangeMode } = this.state;

    if (rearrangeMode) {
      this.props.saveQuestionOrder();
    }
    this.setState({ rearrangeMode: !rearrangeMode });
  };

  setOrderedQuestions = questions => {
    this.props.setOrderedQuestions(questions);
  };

  deleteAnswer = answer => {
    let answers_attributes = this.state.answers_attributes;
    let index = answers_attributes.indexOf(answer);
    answers_attributes[index].is_deleted = true;
    this.setState({ answers_attributes });
  };

  render() {
    const {
      rearrangeMode,
      collapse,
      modalToggle,
      question,
      answer,
      answers_attributes,
      editId,
      editAnswerObject,
      editAnswerText,
      questionError,
      answerError,
    } = this.state;

    return (
      <Fragment>
        <DeleteQuestionModal
          modalToggle={modalToggle}
          cancelQuestionDelete={this.cancelQuestionDelete}
          confirmDeleteQuestion={this.confirmDeleteQuestion}
        />
        <div className="clearfix">
          {rearrangeMode ? null : (
            <Button
              onClick={this.toggleAddtrue}
              className="btn btn-light btn-add-question ml-2"
            >
              <FontAwesomeIcon icon="plus" />
              Add Questions
            </Button>
          )}
          <Button
            onClick={this.handleQuestionArrange}
            className="btn btn-light btn-add-question"
            style={{ backgroundColor: '#afafaf' }}
          >
            <FontAwesomeIcon icon="arrows-alt" />
            {rearrangeMode ? 'Save' : 'Re-arrange Mode'}
          </Button>
        </div>
        <Collapse className="collapse" isOpen={collapse}>
          <AddNewQuestion
            key={collapse}
            addQuestionVisible={collapse}
            toggleAddQuestion={this.toggleAddQuestion}
            addQuestion={this.addQuestion}
          />
        </Collapse>
        {rearrangeMode ? (
          <RearrangeQuestions
            questions={this.props.questions}
            setOrderedQuestions={this.setOrderedQuestions}
          />
        ) : (
          <QuestionsLists
            changeAnswerOrder={this.changeAnswerOrder}
            editId={editId}
            question={question}
            answers_attributes={answers_attributes}
            answer={answer}
            editAnswerObject={editAnswerObject}
            editAnswerText={editAnswerText}
            editQuestion={this.editQuestion}
            editAnswer={this.editAnswer}
            cancelAnswerEdit={this.cancelAnswerEdit}
            confirmAnswerEdit={this.confirmAnswerEdit}
            addAnswer={this.addAnswer}
            cancelEdit={this.cancelEdit}
            deleteQuestion={this.deleteQuestion}
            deleteAnswer={this.deleteAnswer}
            questions={this.props.questions}
            handleChange={this.handleChange}
            confirmEdit={this.confirmEdit}
            handleKeyPress={this.handleKeyPress}
            questionError={questionError}
            answerError={answerError}
          />
        )}
      </Fragment>
    );
  }
}

QuestionsDisplay.defaultProps = {
  fetchDetails: () => {},
  questions: [],
  saveQuestionOrder: () => {},
  setOrderedQuestions: () => {},
};

QuestionsDisplay.propTypes = {
  categoryId: PropTypes.string.isRequired,
  fetchDetails: PropTypes.func,
  questions: PropTypes.instanceOf(Array),
  saveQuestionOrder: PropTypes.func,
  setOrderedQuestions: PropTypes.func,
};

export default withRouter(QuestionsDisplay);



// WEBPACK FOOTER //
// ./src/components/questions/display/QuestionsDisplay.js